import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../context/LoginContext';
import { useNavigate, useParams } from 'react-router-dom';
import { SiPayloadcms } from 'react-icons/si';
import { purchasedValidityLabel } from '../../../utils/premiumPlans';

const PhonePePayment = () => {

  const { isLoggedIn, userId, userData } = useContext(LoginContext);
  const [paymentData, setPaymentData] = useState([]);
  const [activePlan, setActivePlan] = useState([]);
  const param = useParams();
  const navigate = useNavigate();


  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const fetchPaymentStatus = async () => {
      const payload = new FormData();
      payload.append("user_id", userId);
      payload.append("looking", userData.looking_for);
      payload.append("gender", userData.gender);
      payload.append("status", userData.status);
      payload.append("email", userData.email);

      axios.post(`${process.env.REACT_APP_API_PAYMENT_URL}user/checkallpayments`, payload)
        .then(response => {
          setPaymentData(response.data);
          const currentDate = new Date();
          setActivePlan(response.data.filter(item => item.status === "COMPLETED" && new Date(item.valid_upto) > currentDate));
        })
        .catch(error => {
          console.error("There was an error fetching data in header!", error);
        });
    };

    if (param.id) {
      fetchPaymentStatus();
    }
  }, [param.id]);



  return (
    <div>

      <div class="container py-5">
        <div class="row justify-content-center">

          {activePlan.map((res) => (

            <div className="col-md-4 my-3">
              <div className="card mx-auto pricing-card shadow-sm p-3">
                <div className="card-body d-flex " style={{ flexDirection: "column" }}>
                  <span className="badge bg-warning text-dark mb-2 mx-auto">Most Popular Plan</span>
                  <h5 className="card-title text-center">Premium</h5>

                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td> <p className='fw-bold mb-0 fs-4'><span className="fw-bold fs-4">₹ {res.amount/100} </span>/- {purchasedValidityLabel(res.valid_from, res.valid_upto) || '1 Year'}</p> </td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="card-subtitle mb-3 text-muted text-center" style={{ color: "#A16304" }}>
                    Valid From : {(res.valid_from || '').toString().replace(/^(\d{4}-\d{2}-\d{2}):/, '$1 ').substring(0, 10)}
                  </p>

                  <button className="btn btn-danger w-100 mb-3" >
                    Valid Upto: {(res.valid_upto || '').toString().replace(/^(\d{4}-\d{2}-\d{2}):/, '$1 ').substring(0, 10)}
                  </button>


                </div>
              </div>
            </div>

          ))}



          <div className="col-12">
            <div className="payment-history-page">
              <h5 className="fw-bold mb-3 text-center d-md-none">Payment history</h5>
              <div className="payment-history-cards payment-history-cards--mobile">
                {paymentData?.map((res, idx) => (
                  <div className="payment-history-card" key={res.order_id || idx}>
                    <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                      <span className="small text-muted">{res.created_at?.substring(0, 10)}</span>
                      {(res.status === 'COMPLETED') ? (
                        <span className="badge bg-success">Success</span>
                      ) : (
                        <span className="badge bg-danger">Failed</span>
                      )}
                    </div>
                    <p className="mb-1 small"><strong>Order:</strong> <span className="text-break">{res.order_id}</span></p>
                    <p className="mb-1 small"><strong>Mode:</strong> {res.other || 'Cancelled'}</p>
                    <p className="mb-0 small"><strong>Amount:</strong> ₹ {res.amount / 100}</p>
                  </div>
                ))}
              </div>
            <div className="payment-history-table-wrap card" style={{ overflowX: 'auto' }}>
              <div className="table-responsive">
              <table className="table table-bordered mb-0 payment-history-table">
                <thead className='table-head'>
                  <tr>
                    <th>Date</th>
                    <th>Order Id</th>
                    <th>Payment Mode</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>


                  {paymentData?.map((res) =>

                  (<tr className="overdue-row" key={res.order_id}>
                    <td data-label="Date">{res.created_at.substring(0, 10)}</td>
                    <td data-label="Order Id" className="text-break">{res.order_id}</td>
                    <td data-label="Payment Mode">{(res.other)?res.other:"Cancelled"}</td>
                    <td data-label="Amount">₹ {res.amount / 100} </td>
                    <td data-label="Status">
                      {(res.status == "FAILED" || res.status==null) &&
                        (<p class="bg-danger text-white p-1 rounded-2 text-center  ">Failed</p>)}
                      {(res.status == "COMPLETED") &&
                        (<p class="bg-success text-white p-1 rounded-2 text-center  ">Success</p>)}
                    </td>
                  </tr>

                  ))}


                </tbody>
              </table>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .payment-history-card {
          background: #fff;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 14px;
          margin-bottom: 10px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.05);
        }
        .payment-history-page {
          width: 100%;
          overflow-x: hidden;
        }
        .payment-history-cards--mobile {
          display: none;
        }
        .payment-history-table-wrap {
          display: block;
        }
        @media (max-width: 767.98px) {
          .payment-history-cards--mobile {
            display: block !important;
          }
          .payment-history-table-wrap {
            display: none !important;
          }
        }
        @media (min-width: 768px) {
          .payment-history-cards--mobile {
            display: none !important;
          }
        }
      `}</style>


    </div>
  );
};

export default PhonePePayment;
